import api from '../api';

const guardianPropertySearchService = {
  searchProperties: async (filters = {}) => {
    try {
      const response = await api.post('/guardian-property-search', filters);
      return response.data;
    } catch (error) {
      console.error('Error in searchProperties:', error);
      throw error;
    }
  },

  getPropertyDetails: async (propertyId) => {
    try {
      const response = await api.get(
        `/guardian-property-details/${propertyId}/details`
      );
      return response.data;
    } catch (error) {
      console.error('Error in getPropertyDetails:', error);
      throw error;
    }
  },

  requestViewing: async (propertyId, preferences = {}) => {
    try {
      const response = await api.post(
        `/guardian-property-search/${propertyId}/request-viewing`,
        preferences
      );
      return response.data;
    } catch (error) {
      console.error('Error in requestViewing:', error);
      throw error;
    }
  },

  requestMoreInfo: async (propertyId) => {
    try {
      const response = await api.post(
        `/guardian-property-search/${propertyId}/request-info`
      );
      return response.data;
    } catch (error) {
      console.error('Error in requestMoreInfo:', error);
      throw error;
    }
  },

  getAvailableAreas: async () => {
    try {
      const response = await api.get('/guardian-property-search/areas');
      return response.data;
    } catch (error) {
      console.error('Error in getAvailableAreas:', error);
      throw error;
    }
  },
};

export default guardianPropertySearchService;
